import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@fairstone/ui/core/components';
import { t } from '@fairstone/ui/core/providers/Intl/locales/translate';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

import AccountNumberInput from 'components/sto/AccountNumberInput';
import BaseInput from 'components/sto/BaseInput';
import EmailInput from 'components/sto/EmailInput';
import PasswordInput from 'components/sto/PasswordInput';
import ModalSto from 'components/sto/STOModalWrapper';

/*
    STO Container
*/

class ContainerSto extends React.Component {
    render() {
        let container;
        if (this.props.loginPage) {
            container = (
                <div className="container-sto">
                    <div className="fairstone-retail-oam-app-content">{this.props.children}</div>
                    <div className="footer">
                        <FormattedMessage id="footer.text" />
                    </div>
                </div>
            );
        } else {
            container = (
                <div className="container-sto">
                    <div className="bgGrayHeader"></div>

                    <div className="smallWrapper">
                        <div className="page-content fairstone-retail-oam-app-content">{this.props.children}</div>
                    </div>
                    <div className="footer">
                        <FormattedMessage id="footer.text" />
                    </div>
                </div>
            );
        }
        return container;
    }
}

ContainerSto.propTypes = {
    children: PropTypes.node,
};

const PrimaryButtonSto = (props) => {
    const { labelKey, ...otherProps } = props;
    return (
        <Button {...otherProps} appearance="contained" border>
            {t(labelKey)}
        </Button>
    );
};

const TextButtonSto = (props) => {
    const { labelKey, ...otherProps } = props;
    return (
        <Button {...otherProps} appearance="text" border>
            {t(labelKey)}
        </Button>
    );
};

/*
    STO Input
*/

const TextInputSto = (props) => <BaseInput {...props} />;

/* STO-6digits-input*/

const SixDigitsInputSto = ({
    disabled,
    errorMessage,
    isValid,
    label,
    labelAfter,
    labelRedirect,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    validMessage,
    value,
}) => (
    <div className="six-digits-input-elem-sto">
        <div className="six-digits-input-sto-messages">
            <span
                className={
                    (errorMessage && (isValid === false || isValid === true)
                        ? 'six-digits-input-sto-label-hidden '
                        : 'six-digits-input-sto-label ') +
                    (isValid === false ? 'six-digits-input-sto-label-error ' : '')
                }
            >
                {label ? <FormattedMessage id={label} /> : ''}
            </span>
            <span
                className={
                    isValid === false && errorMessage
                        ? 'six-digits-input-sto-error-message '
                        : 'six-digits-input-sto-error-message-hidden '
                }
            >
                {errorMessage ? <FormattedMessage id={errorMessage} /> : ''}
            </span>
            <span
                className={
                    isValid === true && validMessage
                        ? 'six-digits-input-sto-success-message '
                        : 'six-digits-input-sto-success-message-hidden '
                }
            >
                {validMessage ? <FormattedMessage id={validMessage} /> : ''}
            </span>

            <span
                className={
                    'six-digits-input-sto-icon ' + (isValid === true ? 'valid ' : 'six-digits-input-sto-icon-hidden ')
                }
            >
                <Icon theme="filled" type="check-circle" />
            </span>
            <span
                className={
                    'six-digits-input-sto-icon ' + (isValid === false ? 'error ' : 'six-digits-input-sto-icon-hidden ')
                }
            >
                <Icon theme="filled" type="exclamation-circle" />
            </span>
        </div>
        <input
            autoComplete="off"
            className={'six-digits-input-sto ' + (isValid === false ? 'hasError ' : isValid === true ? 'isValid ' : '')}
            disabled={disabled}
            id={name}
            inputMode="tel"
            maxLength="6"
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onClick={onClick}
            onFocus={onFocus}
            type="text"
            value={value}
        />
        <div className="six-digits-input-sto-messages">
            <span
                className={
                    (errorMessage && isValid === false) || (validMessage && isValid === true)
                        ? 'six-digits-input-sto-span-hidden '
                        : 'six-digits-input-sto-span '
                }
            />
            <span
                className={
                    errorMessage && isValid === false
                        ? 'six-digits-input-sto-again '
                        : 'six-digits-input-sto-again-hidden '
                }
            >
                {labelAfter ? <FormattedMessage id={labelAfter} /> : ''}
            </span>
            <span
                className={
                    validMessage && isValid === true
                        ? 'six-digits-input-sto-redirect six-digits-input-sto-redirect-first-line '
                        : 'six-digits-input-sto-redirect-hidden '
                }
            >
                {labelRedirect ? (
                    <FormattedMessage
                        id={labelRedirect}
                        values={{
                            br: <br />,
                        }}
                    />
                ) : (
                    ''
                )}
            </span>
            <span
                className={
                    validMessage && isValid === true
                        ? 'six-digits-input-sto-redirect '
                        : 'six-digits-input-sto-redirect-hidden '
                }
            >
                {labelRedirect ? '...' : ''}
            </span>
        </div>
    </div>
);

SixDigitsInputSto.propTypes = {
    disabled: PropTypes.bool,
    displayPlaceholder: PropTypes.bool,
    errorMessage: PropTypes.string,
    inputType: PropTypes.string,
    isValid: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    type: PropTypes.string,
    validMessage: PropTypes.string,
    value: PropTypes.string,
};

SixDigitsInputSto.defaultProps = {
    disabled: false,
};

export {
    AccountNumberInput,
    ContainerSto,
    EmailInput,
    ModalSto,
    PasswordInput,
    PrimaryButtonSto,
    SixDigitsInputSto,
    TextButtonSto,
    TextInputSto,
};
